import { PHOTO_SOORT } from "../context/InterventionInputContext";

// 1 = lecot live
// 3 = televic live
// 9 = televic demo

const INVOICE_VERSION = 1

export const CUS_SETTINGS: CUS_SETTINGS_TYPE = {
  ["3"]: {
    intervention: {
      start_page: {
        filter_status: [8,9],
        enable_visit_rapport: false,
      },
      optional_data: {
        type_photos: ["FOTO"],
      },
      description: {
        require_solution: true,
        require_solution_extra: true,
      },
      invoicing: {
        enable_triptime: true,
        require_reason_timechange: false,
				version: INVOICE_VERSION,
      },
      settings: {
        enable_kilometers: false,
        enable_hometrip: true,
      },
    },
		calendar: {
			new_activity: {
				filter_status: []
			}
		},
    navigation: {
      calendar: true,
    },
  },
  ["9"]: {
    intervention: {
      start_page: {
				filter_status: [8,9],
        enable_visit_rapport: false,
      },
      optional_data: {
        type_photos: ["FOTO"],
      },
      description: {
        require_solution: true,
        require_solution_extra: true,
      },
      invoicing: {
        enable_triptime: true,
        require_reason_timechange: false,
				version: INVOICE_VERSION,
      },
      settings: {
        enable_kilometers: false,
        enable_hometrip: true,
      },
    },
		calendar: {
			new_activity: {
				filter_status: []
			}
		},
    navigation: {
      calendar: true,
    },
  },
  default: {
    intervention: {
      start_page: {
				filter_status: [8,9],
        enable_visit_rapport: true,
      },
      optional_data: {
        type_photos: ["I_FOTO", "E_FOTO"],
      },
      description: {
        require_solution: false,
        require_solution_extra: false,
      },
      invoicing: {
        enable_triptime: false,
        require_reason_timechange: true,
				version: INVOICE_VERSION,
      },
      settings: {
        enable_kilometers: true,
        enable_hometrip: false,
      },
    },
		calendar: {
			new_activity: {
				filter_status: []
			}
		},
    navigation: {
      calendar: false,
    },
  },
};

type CUS_SETTINGS_TYPE = {
  [databaseId: string]: {
    intervention?: {
      start_page?: {
        enable_visit_rapport?: boolean;
        filter_status?: number[];
      };
      optional_data?: {
        type_photos?: PHOTO_SOORT[];
      };
      description?: {
        require_solution?: boolean;
        require_solution_extra?: boolean;
      };
      invoicing?: {
        enable_triptime?: boolean;
        require_reason_timechange?: boolean;
				version?: 1 | 2;
      };
      settings?: {
        enable_kilometers?: boolean;
        enable_hometrip?:boolean;
      };
    };
		calendar?: {
			new_activity?: {
				filter_status?: number[];
			}
		};
    navigation?: {
      calendar?: boolean;
    };
  };
};

export function getCustomSettings(
  databaseId: number | string | undefined | null
) {
  if (!databaseId) return CUS_SETTINGS.default;
  const settings = CUS_SETTINGS[databaseId?.toString()];
  if (!settings) return CUS_SETTINGS.default;
  return settings;
}
